export enum MessageMark {
    Important = 'important',
    Flagged = 'flagged',
    Commented = 'commented',
}
